import React from 'react';
import { shape, func, string, arrayOf } from 'prop-types';
import ReactSelect, { components } from 'react-select';

import Icon from 'components/icon';

const DropdownIndicator = props => (
    <components.DropdownIndicator {...props}>
        <div
            className={`dropdown-indicator ${
                // eslint-disable-next-line react/prop-types
                props.selectProps.menuIsOpen ? 'is-open' : ''
            }`}
        >
            <Icon glyph="arrow-drop-down" />
        </div>
    </components.DropdownIndicator>
);

const Option = props => (
    <components.Option {...props}>
        {/* eslint-disable-next-line react/prop-types */}
        {props.children}
        {/* eslint-disable-next-line react/prop-types */}
        {props.isSelected && <Icon glyph="check-mark-circle" />}
    </components.Option>
);

const Select = ({ label, name, options, value, onChange }) => {
    const selectedOption = options.find(option => option.value === value);

    if (!options || !options.length) {
        return null;
    }

    return (
        <React.Fragment>
            <label className="u-sr-only" htmlFor={`${name}`}>
                {label}
            </label>
            <ReactSelect
                classNamePrefix="select"
                components={{ DropdownIndicator, Option }}
                value={
                    (selectedOption && selectedOption.value === '') ||
                    !selectedOption
                        ? null
                        : selectedOption
                }
                onChange={onChange}
                options={options}
                id={name}
                isSearchable={false}
                name={name}
            />
        </React.Fragment>
    );
};

Select.propTypes = {
    name: string.isRequired,
    label: string.isRequired,
    value: string.isRequired,
    options: arrayOf(shape({ value: string, label: string })).isRequired,
    onChange: func.isRequired
};

export default Select;
